import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const ListItemStyled = styled(ListItem)`
`
const SideBarListItem = ({
  label,
  icon,
  onChange,
  children,
  ...other
}) => {

  return (
    <ListItemStyled {...other}>
      {
        icon &&
        <ListItemIcon>
          {icon}
        </ListItemIcon>
      }
      <ListItemText primary={label} />
    </ListItemStyled>
  );
}

SideBarListItem.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.object,
};

SideBarListItem.defaultProps = {

};

export default SideBarListItem;